import { initialState } from './state';

export function start(state, payload) {
  Object.assign(state, payload);

  localStorage.setItem('followupSessionPatientId', payload.patientId);
}

export function close(state) {
  Object.assign(state, initialState());

  localStorage.removeItem('followupSessionPatientId');
}

export function restore(state) {
  const patientId = localStorage ? localStorage.getItem('followupSessionPatientId') : '';

  Object.assign(state, { patientId });
}

export function reset(state) {
  if (localStorage){
    localStorage.removeItem('followupSessionPatientId');
  }

  Object.assign(state, initialState());
}
